import { Component, inject } from '@angular/core';
import { ConfirmService } from './confirm.service';
import { Modal } from './modal';

/** Renderizza la conferma richiesta da ConfirmService. Montato una sola volta nello shell. */
@Component({
  selector: 'app-confirm-host',
  imports: [Modal],
  template: `
    @if (request(); as confirm) {
      <app-modal [title]="confirm.title" (closed)="answer(false)">
        <p class="text">{{ confirm.message }}</p>
        <div modalActions>
          <button type="button" class="btn btn-ghost" (click)="answer(false)">Annulla</button>
          <button
            type="button"
            class="btn"
            [class.btn-danger]="confirm.danger"
            [class.btn-primary]="!confirm.danger"
            (click)="answer(true)"
          >
            {{ confirm.confirmLabel }}
          </button>
        </div>
      </app-modal>
    }
  `,
  styles: `
    .text {
      color: var(--text-secondary);
      font-size: 14px;
      line-height: 1.55;
      text-wrap: pretty;
    }
  `,
})
export class ConfirmHost {
  private confirm = inject(ConfirmService);
  protected readonly request = this.confirm.pending;

  protected answer(confirmed: boolean): void {
    this.confirm.answer(confirmed);
  }
}
